import React from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import { NavLink } from "react-router-dom";
import { Nav, NavItem } from "reactstrap";

function SmallScreenFooter({ isSubUser, isSender, translate, handleLogout }) {
  return (
    <footer className="footer ls-screen-hidden">
      <nav className="navbar navbar-expand navbar-light">
        <Nav navbar>
          {!isSubUser && (
            <NavItem className="nav-footer-item">
              <NavLink
                to="/dashboard"
                activeClassName="active"
                className="nav-link default-top-bar-color w_action_top_menu orange_button text-center"
              >
                <i className="fa fa-2x fa-chart-line" />
                <div style={{ marginTop: "0.5rem" }}>
                  {translate("Dashboard")}
                </div>
              </NavLink>
            </NavItem>
          )}
          {isSubUser && !isSender && (
            <NavItem className="nav-footer-item">
              <NavLink
                to="/home"
                activeClassName="active"
                className="nav-link default-top-bar-color w_action_top_menu orange_button text-center"
              >
                <i className="fa fa-2x fa-home" />
                <div style={{ marginTop: "0.5rem" }}>{translate("Home")}</div>
              </NavLink>
            </NavItem>
          )}
          <NavItem className="nav-footer-item">
            <NavLink
              to="/files"
              activeClassName="active"
              className="nav-link default-top-bar-color w_action_top_menu orange_button text-center"
            >
              <i className="fa fa-2x fa-file-archive" />
              <div style={{ marginTop: "0.5rem" }}>{translate("Files")}</div>
            </NavLink>
          </NavItem>
          <NavItem className="nav-footer-item">
            <NavLink
              to="/documents"
              activeClassName="active"
              className="nav-link default-top-bar-color w_action_top_menu orange_button text-center"
            >
              <i className="fa fa-2x fa-file-alt" />
              <div style={{ marginTop: "0.5rem" }}>
                {translate("Documents")}
              </div>
            </NavLink>
          </NavItem>
        </Nav>
        <ul className="navbar-nav">
          {!isSubUser && (
            <NavItem className="nav-footer-item">
              <NavLink
                to="/smart-search"
                activeClassName="active"
                style={{ padding: "10px" }}
                className="nav-link default-top-bar-color w_action_top_menu orange_button text-center"
              >
                <i className="fa fa-2x fa-search" />
                <div style={{ marginTop: "0.5rem" }}>{translate("Search")}</div>
              </NavLink>
            </NavItem>
          )}
          <li className="nav-item nav-footer-item">
            <button
              onClick={() => {
                handleLogout();
              }}
              className="nav-link default-top-bar-color w_action_top_menu"
              data-action="logoff"
            >
              <i className="fa fa-2x fa-sign-out-alt" />
              <div style={{ marginTop: "0.5rem" }}>{translate("LogOff")}</div>
            </button>
          </li>
        </ul>
      </nav>
    </footer>
  );
}

function mapStateToProps(state) {
  const {
    locale,
    authentication: { isSubUser, isSender },
  } = state;
  return {
    isSubUser,
    isSender,
    translate: getTranslate(locale),
  };
}

const connectedSmallScreenFooter = connect(mapStateToProps)(SmallScreenFooter);
export { connectedSmallScreenFooter as SmallScreenFooter };
